import BonusProgramModule from './BonusProgram';

export default BonusProgramModule;
